// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file quanterix/simoa_one/analysis_app_api/v1/update_assay_data_request.proto (package quanterix.simoa_one.analysis_app_api.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { FieldMask } from "../../../../google/protobuf/field_mask_pb";
import { file_google_protobuf_field_mask } from "../../../../google/protobuf/field_mask_pb";
import type { AssayData } from "./assay_data_pb";
import { file_quanterix_simoa_one_analysis_app_api_v1_assay_data } from "./assay_data_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file quanterix/simoa_one/analysis_app_api/v1/update_assay_data_request.proto.
 */
export const file_quanterix_simoa_one_analysis_app_api_v1_update_assay_data_request: GenFile = /*@__PURE__*/
  fileDesc("CkdxdWFudGVyaXgvc2ltb2Ffb25lL2FuYWx5c2lzX2FwcF9hcGkvdjEvdXBkYXRlX2Fzc2F5X2RhdGFfcmVxdWVzdC5wcm90bxIncXVhbnRlcml4LnNpbW9hX29uZS5hbmFseXNpc19hcHBfYXBpLnYxIroBChZVcGRhdGVBc3NheURhdGFSZXF1ZXN0EksKCmFzc2F5X2RhdGEYASABKAsyMi5xdWFudGVyaXguc2ltb2Ffb25lLmFuYWx5c2lzX2FwcF9hcGkudjEuQXNzYXlEYXRhSACIAQESNAoLdXBkYXRlX21hc2sYAiABKAsyGi5nb29nbGUucHJvdG9idWYuRmllbGRNYXNrSAGIAQFCDQoLX2Fzc2F5X2RhdGFCDgoMX3VwZGF0ZV9tYXNrYgZwcm90bzM", [file_google_protobuf_field_mask, file_quanterix_simoa_one_analysis_app_api_v1_assay_data]);

/**
 * Rpc request to save a created or modified assay as a new assay
 *
 * @generated from message quanterix.simoa_one.analysis_app_api.v1.UpdateAssayDataRequest
 */
export type UpdateAssayDataRequest = Message<"quanterix.simoa_one.analysis_app_api.v1.UpdateAssayDataRequest"> & {
  /**
   * Assay data to be updated
   *
   * @generated from field: optional quanterix.simoa_one.analysis_app_api.v1.AssayData assay_data = 1;
   */
  assayData?: AssayData;

  /**
   * Represents a set of field paths to be modified by the update request. If
   * omitted, all fields all fields in assay_data are updated in storage.
   *
   * See: https://protobuf.dev/reference/protobuf/google.protobuf/#field-mask
   *
   * @generated from field: optional google.protobuf.FieldMask update_mask = 2;
   */
  updateMask?: FieldMask;
};

/**
 * Describes the message quanterix.simoa_one.analysis_app_api.v1.UpdateAssayDataRequest.
 * Use `create(UpdateAssayDataRequestSchema)` to create a new message.
 */
export const UpdateAssayDataRequestSchema: GenMessage<UpdateAssayDataRequest> = /*@__PURE__*/
  messageDesc(file_quanterix_simoa_one_analysis_app_api_v1_update_assay_data_request, 0);

